import { loadGoogleMapsPromise } from "../googleMapsLoader";

export const MANUAL_ZONE_SUGGESTIONS = Object.freeze([
  "Angelópolis, Puebla",
  "Centro Histórico, Puebla",
  "Cholula, Puebla",
  "La Paz, Puebla",
  "FINSA, Puebla",
]);

export const normalizeManualZone = value => String(value || "")
  .replace(/\s+/g, " ")
  .trim()
  .slice(0, 120);

export const manualZoneQuery = value => {
  const zone = normalizeManualZone(value);
  if (!zone || !/[a-záéíóúñ]/i.test(zone) || zone.length < 3) return null;
  return /\bpuebla\b|\bm[eé]xico\b/i.test(zone) ? zone : `${zone}, Puebla, México`;
};

const coordinateValue = (location, method) => {
  const value = location?.[method];
  return Number(typeof value === "function" ? value.call(location) : value);
};

export const resolveManualZone = async (value, options = {}) => {
  const query = manualZoneQuery(value);
  if (!query) return { ok: false, error: "Escribe una ciudad, colonia, zona o referencia válida." };

  let googleObject = options.googleObject;
  try {
    if (!googleObject) googleObject = await (options.loadGoogleMaps || loadGoogleMapsPromise)(options.loaderOptions);
  } catch (error) {
    return { ok: false, error: error?.message || "No pudimos validar la zona. Revisa tu conexión e inténtalo de nuevo." };
  }

  const Geocoder = googleObject?.maps?.Geocoder;
  if (!Geocoder) return { ok: false, error: "No pudimos validar la zona con Google Maps." };

  return new Promise(resolve => {
    let settled = false;
    const finish = result => {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      resolve(result);
    };
    const timer = setTimeout(() => finish({ ok: false, error: "La validación de la zona tardó demasiado. Intenta nuevamente." }), options.timeoutMs || 10000);
    const geocoder = new Geocoder();
    geocoder.geocode({ address: query, componentRestrictions: { country: "MX" } }, (results, status) => {
      const match = status === "OK" ? results?.[0] : null;
      const latitude = coordinateValue(match?.geometry?.location, "lat");
      const longitude = coordinateValue(match?.geometry?.location, "lng");
      if (!match || !Number.isFinite(latitude) || !Number.isFinite(longitude)) {
        finish({ ok: false, error: "No encontramos esa zona. Prueba con colonia, ciudad y estado." });
        return;
      }
      finish({
        ok: true,
        zone: normalizeManualZone(match.formatted_address || query),
        query,
        coords: { latitude, longitude },
        placeId: match.place_id || null,
      });
    });
  });
};
